<div class="flex flex-col">
  <div class="flex flex-row text-sm color-primary">
    <span>{{item()['kassennummer']}}</span>
    @if(item().kzaktiv === 'N'){
    <span
      class="bg-danger-500 text-danger-contrast inline-block py-1 px-1.5 text-xs font-semibold"
      >Inaktiv</span
    >
    }
  </div>
  <div class="flex flex-row">
    <span class="font-bold">{{item()['bezeichnung']}}</span>
  </div>
</div>
